// extracted by mini-css-extract-plugin
export default {"root":"item_root__OwnQM"};